import { consent } from 'vue-gtag';

// Function to get a cookie
function getCookie(cname: string): string {
  const name = `${cname}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return 'false';
}

// Initialize dataLayer and Consent
export function initConsent() {
  consent('update', {
    ad_storage:
      getCookie('cookies-bar-consent-marketing') === 'true'
        ? 'granted'
        : 'denied',
    ad_user_data:
      getCookie('cookies-bar-consent-marketing') === 'true'
        ? 'granted'
        : 'denied',
    ad_personalization:
      getCookie('cookies-bar-consent-marketing') === 'true'
        ? 'granted'
        : 'denied',
    analytics_storage:
      getCookie('cookies-bar-consent-analytic') === 'true'
        ? 'granted'
        : 'denied',
    personalization_storage:
      getCookie('cookies-bar-consent-preferential') === 'true'
        ? 'granted'
        : 'denied',
  });
}
